

// ==============================|| FOOTER - AUTHENTICATION ||============================== //

const AuthFooter = () => {


  return <></>;
};

export default AuthFooter;
